
var { isMobile } = require("./lib/breakpoints");
var { makeTranslate, classify } = require("./lib/helpers");

var d3 = {
  ...require("d3-selection/dist/d3-selection.min"),
  ...require("d3-scale/dist/d3-scale.min"),
  ...require("d3-axis/dist/d3-axis.min")
};

var { COLORS, makeTranslate, classify, fmtComma } = require("./lib/helpers");

// Render a bar chart.
module.exports = function(config) {
  // Setup
  var labelColumn = "plaintiff";
  var valueColumn = "amt";

  var blockHeight = 10;
  if (isMobile.matches) {
    blockHeight = 7;
  }

  var blockGap = 1;

  var margins = {
    top: 20,
    right: 20,
    bottom: 50,
    left: 15
  };

  var ticksY = 5;

  // Determine largest bin
  var largestBin = Math.max.apply(
    null,
    config.data.map(b => b.length)
  );

  // Calculate actual chart dimensions
  var chartWidth = config.width - margins.left - margins.right;
  var chartHeight = (blockHeight + blockGap) * largestBin;

  // Clear existing graphic (for redraw)
  var containerElement = d3.select(config.container);
  containerElement.html("");

  // Create the root SVG element.
  var chartWrapper = containerElement
    .append("div")
    .attr("class", "graphic-wrapper");

  var chartElement = chartWrapper
    .append("svg")
    .attr("width", chartWidth + margins.left + margins.right)
    .attr("height", chartHeight + margins.top + margins.bottom)
    .append("g")
    .attr("transform", makeTranslate(margins.left, margins.top));

  // Create D3 scale objects.
  var xScale = d3
    .scaleBand()
    .domain(config.bins.slice(0, -1))
    // this changes the range in which ticksY span on the xAxis
    .range([40, chartWidth])
    .padding(0.1);

  var yScale = d3
    .scaleLinear()
    .domain([0, largestBin])
    .range([chartHeight, 0]);

  // Create D3 axes.
  var xAxis = d3
    .axisBottom()
    .scale(xScale)
    // .ticks(4)
    .tickValues(isMobile.matches ? [0, 50000, 100000, 150000, 200000, 250000] : bins)
    .tickFormat((d) => {
      var label = ""
      if (isMobile.matches){
        if (d % 50000 == 0){
          label = "$" + (d/1000).toFixed(0) + "K" 
        } else {
          label = ""
        }
        return label
      } else if (d % 25000 == 0){
          label = "$" + (d/1000).toFixed(0) + "K" 
        } else {
          label = ""
        } 
        return label
    });


  var yAxis = d3
    .axisLeft()
    .scale(yScale)
    .ticks(ticksY)
    // .tickSize(-chartWidth, 0)
    .tickFormat(d => d)

  // Render axes to chart.
  var xAxisElement = chartElement
    .append("g")
    .attr("class", "x axis")
    .attr("transform", makeTranslate(0, chartHeight))
    .call(xAxis);

  d3.select(".x.axis .domain").remove();

  // Create xAxis label
  xAxisElement
    .append("text")
    .attr("class", "label-xaxis")
    .attr("transform", makeTranslate(chartWidth / 2, margins.bottom - 7 ))
    .style("font-size", 12)
    .html(LABELS.title_x);

  // Render grid to chart.
  var yAxisGrid = function() {
    return yAxis;
  };

  var yAxisElement = chartElement
    .append("g")
    .attr("class", "y grid")
    .call(
      yAxisGrid()
        .tickSize(-chartWidth, 0)
    //     .tickFormat(d => d)
    );

  yAxisElement
    .select(".tick:last-of-type text")
    .clone()
    .attr("x", "2.5em")
    .attr("class", "shadow")
    .text(LABELS.title_y)
    .clone()
    .attr("class", "label")
    .text(LABELS.title_y);

  var bandwidth = xScale.bandwidth();
  var shift = -(bandwidth / 2) - (bandwidth * 0.1) / 2;
  var tickShift = function(d, i) {
    var existing = this.getAttribute("transform").match(
      /translate\(([^)]+)\)/
    )[1];
    existing = existing.split(",").map(Number);
    existing[0] += shift;
    existing[1] += 3;
    return makeTranslate(...existing);
  };

  // Shift tick marks
  chartElement.selectAll(".x.axis .tick").attr("transform", tickShift);

  var lastTick = chartElement
    .select(".x.axis")
    .append("g")
    .attr("class", "tick")
    .attr("transform", function() {
      var lastBin = xScale.domain()[xScale.domain().length - 1];

      var x = xScale(lastBin) + bandwidth + (bandwidth * 0.1) / 2;
      var y = 3;
      return makeTranslate(x, y);
    });

  lastTick
    .append("line")
    .attr("x1", 0)
    .attr("x2", 0)
    .attr("y1", 0)
    .attr("y2", 6)
    .attr("class", "highlight-tick");

  lastTick
    .append("text")
    .attr("text-anchor", "middle")
    .attr("x", 0)
    .attr("y", 9)
    .attr("dy", "0.71em")
    .attr("fill", "currentColor")
    .text(function() {
      var t = config.bins[config.bins.length - 1];
      if (t > 0) {
        return "$" + (t/1000).toFixed(0) + "K"  ;
      }
    });

  // highlight the ticks
  var xTickLines = chartElement.selectAll(".x .tick line");

  xTickLines.each(function (d) {
    if (isMobile.matches){
      if (d % 50000 == 0) {
        d3.select(this).classed("highlight-tick", true);
      }} else if (d % 25000 == 0) {
        d3.select(this).classed("highlight-tick", true);
      }
  });

  // Render bins to chart.
  var bins = chartElement
    .selectAll(".bin")
    .data(config.data)
    .enter()
    .append("g")
    .attr("class", (d, i) => "bin bin-" + i)
    .attr("transform", (d, i) => makeTranslate(xScale(config.bins[i]), 0));

  bins
    .selectAll("rect")
    .data(function(d, i) {
      // add the bin index to each row of data so we can assign the right color
      var formattedData = [];
      Object.keys(d).forEach(function(k) {
        var v = d[k];
        formattedData.push({ key: k, value: v, parentIndex: i });
      });
      return formattedData;
    })
    .enter()
    .append("rect")
    .attr("width", xScale.bandwidth())
    .attr("x", 0)
    .attr("y", (d, i) => chartHeight - (blockHeight + blockGap) * (i + 1))
    .attr("height", blockHeight)
    .attr("fill", function(d){
      if (d.value.hospitalized == "yes"){
        return "#A23520"
      } else {
        return "#ECA395"
      }
    })
    .attr("class", d => classify(d.value.plaintiffs));

  // Render bin values.
  bins
    .append("g")
    .attr("class", "value")
    // hide labels for individual cases
    // .selectAll("text")
    // .data(function(d) {
    //   return Object.keys(d).map(key => ({ key, value: d[key] }));
    // })
    .enter()
    .append("text")
    .attr("text-anchor", "middle")
    .attr("x", xScale.bandwidth() / 2)
    .attr("y", (d, i) => chartHeight - (blockHeight + blockGap) * (i + 1))
    .attr("dy", blockHeight / 2 + 4)
    .text(d => d.value);

  // Render annotations
  var annotations = chartElement.append("g").attr("class", "annotations");

  // create rect behind annotation for keys
  annotations
  .append('rect')
  .attr("class", "rect-outlier")
  .attr("rx", 6)
  .attr("ry", 6)
  .attr("x", xScale(0) + (xScale.bandwidth() * (isMobile.matches ? 53 : 59.5)))
  .attr('y', isMobile.matches ? 64 : 140)
  .attr('width', isMobile.matches ? 53 : 52)
  .attr('height', isMobile.matches ? 14 : 16)
  .attr('fill', '#ECA395');

  annotations
  .append('rect')
  .attr("class", "rect-outlier")
  .attr("rx", 6)
  .attr("ry", 6)
  .attr("x", xScale(0) + (xScale.bandwidth() * (isMobile.matches ? 53 : 59.5)))
  .attr('y', isMobile.matches ? 81 : 160)
  .attr('width', isMobile.matches ? 57 : 60)
  .attr('height', isMobile.matches ? 14 : 16)
  .attr('fill', '#A23520');

  // background for annotation label
  annotations
  .append('rect')
  .attr("class", "rect-outlier")
  .attr("rx", 6)
  .attr("ry", 6)
  .attr("x", xScale(0) + (xScale.bandwidth() * (isMobile.matches ? 52.5 : 59.2)))
  .attr('y', isMobile.matches ? 50 : 125)
  .attr('width', 80)
  .attr('height', 13)
  .attr('fill', '#fff');

  // annotation text
  annotations
    .append("text")
    .attr("class", "label-outlier")
    .attr("x", xScale(0) + (xScale.bandwidth() * (isMobile.matches ? 53 : 59.5)))
    // .attr("dx", isMobile.matches ? 220 : 575)
    .attr("text-anchor", "begin")
    .attr("y", isMobile.matches ? 60 : 135)
    .html(isMobile.matches ? LABELS.annotation_outlier_m : LABELS.annotation_outlier);

  // annotate median payout
    annotations
    .append("line")
    .attr("class", "axis-median")
    .attr("stroke-width", isMobile.matches ? 1.7 : 2)
    .attr("x1", xScale(0) + (xScale.bandwidth() * 4.5))
    .attr("y1", 0)
    .attr("x2", xScale(0) + (xScale.bandwidth() * 4.5))
    .attr("y2", chartHeight);

  annotations
    .append("text")
    .attr("class", "label-median")
    .attr("x", xScale(0) + (xScale.bandwidth() * 5))
    .attr("text-anchor", "begin")
    .attr("y", isMobile.matches ? 7 : 8)
    .html(LABELS.annotation_median)

};